import { Button, Form, Modal, Spin } from 'antd';
import React, { ReactElement, useCallback, useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { applicationSelector } from '~Applications/selectors';
import { applicationGetAction, applicationValueSetAction } from '~Applications/actions';
import { IGlobalState } from '~reducer';
import IApplication from '~Api/Application/IApplication';
import ModalStateEnum from '~UI/ModalStateEnum';
import WysiwygEditor from '~UI/WysiwygEditor';

export default function FormalApprovalEditModal(props: {
    applicationUuid: string;
    isOpen: ModalStateEnum;
    onCancel: () => void;
}): ReactElement {
    const { applicationUuid, isOpen, onCancel } = props;

    const application: IApplication = useSelector((state: IGlobalState) => applicationSelector(state, applicationUuid));

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!application) {
            dispatch(applicationGetAction(applicationUuid));
        }
    }, [
        application,
        applicationUuid,
        dispatch,
    ]);

    const onChangeConditions: (conditions: string) => void = useCallback((conditions: string) => {
        dispatch(applicationValueSetAction(applicationUuid, 'formalApprovalConditions', conditions));
    }, [
        applicationUuid,
        dispatch,
    ]);

    const onChangeTerms: (terms: string) => void = useCallback((terms: string) => {
        dispatch(applicationValueSetAction(applicationUuid, 'formalApprovalTerms', terms));
    }, [
        applicationUuid,
        dispatch,
    ]);

    const modalFooter: JSX.Element = (
        <Button key='cancel' onClick={onCancel}>Close</Button>
    );

    if (!application) {
        return (
            <Modal
                footer={modalFooter}
                onCancel={onCancel}
                open={ModalStateEnum.Open === isOpen}
                title='Edit Formal Approval'
                width={1000}
                wrapClassName='application-formal-approval-edit-modal'
            >
                <Spin />
            </Modal>
        );
    }

    return (
        <Modal
            footer={modalFooter}
            onCancel={onCancel}
            open={ModalStateEnum.Open === isOpen}
            title='Edit Formal Approval'
            width={1000}
            wrapClassName='application-formal-approval-edit-modal'
        >
            <Form.Item label='Conditions' className='conditions'>
                <WysiwygEditor
                    bold={true}
                    italic={true}
                    onChange={onChangeConditions}
                    orderedList={true}
                    underline={true}
                    unorderedList={true}
                    value={application.formalApprovalConditions}
                />
            </Form.Item>
            <Form.Item label='Terms' className='terms'>
                <WysiwygEditor
                    bold={true}
                    italic={true}
                    onChange={onChangeTerms}
                    orderedList={true}
                    underline={true}
                    unorderedList={true}
                    value={application.formalApprovalTerms}
                />
            </Form.Item>
        </Modal>
    );
}